import React, {useState, useEffect} from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import UserLeftPanel from "../include/UserLeftPanel";
import Global from "../../APIConfig";
import  axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../../AuthUser";
import { useNavigate,useParams } from 'react-router-dom';
import MainLoader from "../Loaders/MainLoader";

function DispatcherEdit(){
    let navigate = useNavigate();
    const {UniqueId} = useParams();
    const{headers1,headers2,logout}=AuthUser();
    const [Name, setName] = useState('');
    const [Phone, setPhone] = useState('');
    const [Email, setEmail] = useState('');
    const [Username, setUsername] = useState('');
    const [Zip, setZip] = useState('');
    const [Country, setCountry] = useState('');
    const [City, setCity] = useState('');
    const [Hub, setHub] = useState('');
    const [Address, setAddress] = useState('');
    const [Countrylist, setCountrylist] = useState([]);
    const [Citylist, setCitylist] = useState([]);
    const [Hublist, setHublist] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [Subloading, setSubloading] = useState(false);
    const [Password, setPassword] = useState('');
    const [ConfirmPassword, setConfirmPassword] = useState('');

    useEffect(()=>{
        GetDispatcherDetail();
        GetCountrylist();
    },[]);
    const GetDispatcherDetail=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'GetDispatcherDetailForEdit',
            headers:headers2,
            data: {
                UniqueId:UniqueId
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setName(data.name);
                setPhone(data.mobile);
                setEmail(data.email);
                setZip(data.pin_code);
                setCountry(data.country);
                setCity(data.branch_location);
                setHub(data.dispatcher_hubid);
                setAddress(data.address);
                handleCountryChange(data.country);
                handleCityChange(data.branch_location);
                setLoading(false);
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                // logout();
                // navigate('/');
                // window.location.reload();
            }
            // console.log(error);
            setLoading(false);
          });
    }
    const GetCountrylist=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Countrylist',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCountrylist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }
    const GetCityList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Citylist',
            data: {
                name: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCitylist(data);
            }
            else
            {
                setCitylist([]);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }
    const handleCountryChange = (val) => {
        setCountry(val);
        GetCityList(val);
    };
    const handleCityChange = (val) => {
        setCity(val);
        GetHubList(val);
    };
    const GetHubList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Hublist',
            data: {
                cityid: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setHublist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }
    const handleSubmit=()=>{
        if(Name==""){
            toast.warning('Dispatcher Name is Required');
        }
        else if(Phone==""){
            toast.warning('Dispatcher Phone NO. is Required');
        }
        else if(Email==""){
            toast.warning('Dispatcher Email is Required');
        }
        else if(Zip==""){
            toast.warning('Postal Code is Required');
        }
        else if(Country==""){
            toast.warning('Please Select Country');
        }
        else if(City==""){
            toast.warning('Please Select City');
        }
        else if(Hub==""){
            toast.warning('Please Select Hub');
        }
        else if(Address==""){
            toast.warning('Address is Required');
        }
        else{
            setSubloading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'EditDispatcher',
                headers:headers2,
                data: {
                    UniqueId:UniqueId,
                    Name:Name,
                    Phone:Phone,
                    Email:Email,
                    Username:Username,
                    Zip:Zip,
                    Country:Country,
                    City:City,
                    Hub:Hub,
                    Address:Address
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                    setTimeout(() => {
                        navigate('/DispatcherList');
                      }, 1000);
                }else{
                    toast.warning(response.data.message);
                }
                setSubloading(false);
              })
              .catch(function (error) {
                setSubloading(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    // logout();
                    // navigate('/');
                    // window.location.reload();
                }
              });
        }
    }

    const handlePassSubmit=()=>{
            if(Password==""){
                toast.warning('Password is Required');
            }
            else if(ConfirmPassword==""){
                toast.warning('Confirm Password is Required');
            }
            else if(Password!=ConfirmPassword){
                toast.warning('Password And Confirm Password Must Be Same');
            }
            else{
                setSubloading(true);
                axios({
                    method: 'post',
                    url: Global.baseUrl+'DispatcherChangePassword',
                    headers:headers1,
                    data: {
                        UniqueId:UniqueId,
                        Password:Password
                    }
                  })
                  .then(function (response) {
                    if(response.data.status == 200)
                    {
                        toast.success(response.data.message);
                        setTimeout(() => {
                            navigate('/DispatcherList');
                          }, 1000);
                    }else{
                        toast.warning(response.data.message);
                    }
                    setSubloading(false);
                  })
                  .catch(function (error) {
                    setLoading(false);
                    setSubloading(false);
                    if(error.response.status==401){
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                  });
            }
        }

    return(
        <>
            <UserLeftPanel/>
            <main className='home-section'>
                <Header/>
                <ToastContainer/>
                {Loading==true?<MainLoader/>
                :
                <>
                    <section className="left_sub_menu">
                        <div className="row">
                            <div className="col-12 col-md">
                                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                                    <div className="d-block mb-4 mb-md-0">
                                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                                <li className="breadcrumb-item">
                                                    <a href="/Admin-Dash">
                                                    <i className="bx bx-home text-primary-400 fs-6"></i>
                                                    </a>
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">Edit Dispatcher</li>
                                            </ol>
                                        </nav>
                                        <div className="d-flex justify-content-between">
                                            <div className="">
                                                <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                                <i className="bx bx-arrow-back "></i>
                                                </button>
                                            </div>
                                            <div className="ps-2 ">
                                                <h2 className="h4">Edit Dispatcher</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="btn-toolbar mb-2 mb-md-0">
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-body">
                                    <h6>Edit Dispatcher</h6>
                                        <div className="row">
                                            <div className="col-12 mb-3 mt-4">
                                                <strong>Dispatcher Basic Details</strong>
                                                <div className="row">
                                                    <div className="col-4 mb-3">
                                                        <label htmlFor="" className="form-label">Name: <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" value={Name} onChange={(e)=>setName(e.target.value)} placeholder="Please Enter Dispatcher Name" />
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <label htmlFor="" className="form-label">Phone: <span className="text-danger">*</span></label>
                                                        <input type="number" className="form-control" value={Phone} onChange={(e)=>setPhone(e.target.value)} placeholder="Please Enter Dispatcher Phone No." />
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <label htmlFor="" className="form-label">Email: <span className="text-danger">*</span></label>
                                                        <input type="email" className="form-control" value={Email} onChange={(e)=>setEmail(e.target.value)} placeholder="Please Enter Dispatcher Email" />
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <label htmlFor="" className="form-label">Postal Code: <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" value={Zip} onChange={(e)=>setZip(e.target.value)} placeholder="Please Enter Dispatcher Postal Code" />
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <div><label htmlFor="email" className="form-label">Country: <span className="text-danger">*</span></label></div>
                                                        <select className="form-select" onChange={(e)=>handleCountryChange(e.target.value)}>
                                                            <option value="">-- Please Select --</option>
                                                            {Countrylist.map((list)=>{
                                                                return (
                                                                    <option selected={Country==list.country?true:false} value={list.country}>{list.country}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <div><label htmlFor="email" className="form-label">City: <span className="text-danger">*</span></label></div>
                                                        <select className="form-select" onChange={(e)=>handleCityChange(e.target.value)}>
                                                            <option value="">-- Please Select --</option>
                                                            {Citylist.map((list)=>{
                                                                return (
                                                                    <option selected={list.value==City?true:false} value={list.value}>{list.label}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-4 mb-3">
                                                        <div><label htmlFor="email" className="form-label">Hub: <span className="text-danger">*</span></label></div>
                                                        <select className="form-select" onChange={(e)=>setHub(e.target.value)}>
                                                            <option value="">-- Please Select --</option>
                                                            {Hublist.map((list)=>{
                                                                return (
                                                                    <option selected={list.value==Hub?true:false} value={list.value}>{list.label}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label htmlFor="" className="form-label">Address: <span className="text-danger">*</span></label>
                                                        <textarea value={Address} className="form-control" rows={5} onChange={(e)=>setAddress(e.target.value)} placeholder="Please Enter Dispatcher Address" ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {Subloading==false?
                                        <div className="d-grid col-md-2 mt-2">
                                            <button className="btn btn-primary" onClick={()=>handleSubmit()}>Submit</button>
                                        </div>
                                        :
                                        <div className="d-grid col-md-2 mt-2">
                                            <a href="" className="btn btn-primary btn-block"> <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading...</span></div></a>
                                        </div>
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                    <section className="left_sub_menu pt-2">
                        <div className="card">
                            <div className="card-body">
                                <h6>Change Dispatcher Password</h6>
                                <div className="row">
                                    <div className="col-12 mb-3 mt-4">
                                        <div className="row">
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Password: <span className="text-danger">*</span></label>
                                                <input type="password" className="form-control" onChange={(e)=>setPassword(e.target.value)} placeholder="Please Enter Password" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Confirm Password: <span className="text-danger">*</span></label>
                                                <input type="password" className="form-control" onChange={(e)=>setConfirmPassword(e.target.value)} placeholder="Please Enter Confirm Password" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {Subloading==false?
                                <div className="d-grid col-md-2 mt-2">
                                    <button className="btn btn-primary" onClick={()=>handlePassSubmit()}>Submit</button>
                                </div>
                                :
                                <div className="d-grid col-md-2 mt-2">
                                    <a href="" className="btn btn-primary btn-block"> <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading...</span></div></a>
                                </div>
                                }
                            </div>
                        </div>
                    </section>
                </>
                }
                <Footer/>
            </main>
        </>
    )
}
export default DispatcherEdit;